<template>
    <div>
      <b-navbar toggleable="sm" type="dark" variant="" class="navbar-container">
        <b-container>
            <b-navbar-brand @click="goHome()">
              <img src="../assets/img/lp_swish_140x120.gif" height="50" class="d-inline-block align-middle" alt="Logo">
              LearningPlanet.com
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav >
              <b-navbar-nav>
                <b-nav>
                  <b-nav-item class="px-2" to="/">Home</b-nav-item>
                  <b-nav-item class="px-2" to="/Students" :class="{'router-link-sub-active': subIsActive('/Students')}">Students</b-nav-item>
                  <b-nav-item class="px-2" to="/games">Games</b-nav-item>
                  <b-nav-item class="px-2" to="/help">Help</b-nav-item>
                  <b-nav-item class="px-2" to="/about">About</b-nav-item>
                </b-nav>
              </b-navbar-nav>
            </b-collapse>
            
          </b-container>
      </b-navbar>
    </div>  
</template>
<script>
export default {
    data() {
        return {
            meal: ''
        }
    },
  methods: {
    subIsActive(input) {

      const paths = Array.isArray(input) ? input : [input]

      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0 // current path starts with this path string
        })
    },
    goHome(){
      this.$router.push("/");
    }
  }
}    
</script>

<style scoped>
.router-link-exact-active {
  background:#FFCC00;
  color: black !important;
}
.router-link-sub-active {
  background:#FFCC00;
  color: black!important;
}

.router-link-sub-active a {
  color: black!important;
}

.navbar-container {
  background-color: #003366;
}
</style>